export default "__VITE_ASSET__ae1c62be__"